import { render, staticRenderFns } from "./installRecords.vue?vue&type=template&id=2609fdd8&scoped=true"
import script from "./installRecords.vue?vue&type=script&lang=js"
export * from "./installRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2609fdd8",
  null
  
)

export default component.exports